<template>
	<popup title="Delete funnel" small @close="closePopup">
		<template v-slot:content>
			<p>
				Are you sure? You'd like to delete this funnel:
			</p>
			<ul class="margin-b-20">
				<li>
					<b>
						{{ funnel.name }}
					</b>
				</li>
			</ul>
		</template>
		<template v-slot:actions>
			<v-button label="Delete funnel" red border @click="deleteFunnel" :loading="loading" />
			<v-button label="Keep funnel" @click="closePopup" />
		</template>
	</popup>
</template>

<script>
import API from "@/api"
import VButton from "@/components/base/v-button";
import VSwitch from "@/components/base/v-switch";
import Popup from "@/components/base/popup";
import {mapGetters} from "vuex";

export default {
  name: "DeleteFunnelPopup",
	components: {Popup, VSwitch, VButton},
	props:['funnel'],
  mixins: [API],
  data() {
    return {
      loading: false,
    }
  },
	computed:{
		...mapGetters(['getAllFunnels','getAllSubFunnels'])
	},
  methods: {
    closePopup() {
      this.$emit('close')
    },
	  removeFunnel() {
		  let f = this.getAllFunnels.findIndex(item => {
			  return item.id === this.funnel.id
		  });
		  if (f>=0) {
			  let oldFunnel = this.getAllFunnels[f];
			  this.getAllFunnels.splice(f, 1);
			  if (oldFunnel.funnel_type===1) { // FPLUS
				  let sfIndex = 0;
				  this.getAllSubFunnels.forEach(sf => { // Delete all Geo funnels inside this funnel.
					  if (sf.funnel_group_id===oldFunnel.funnel_group_id) {
						  if (sfIndex>=0) this.getAllSubFunnels.splice(sfIndex, 1);
					  }
					  sfIndex++;
				  });
			  }
		  }
		  else console.log("remove funnel not found", this.funnel.id)

		  let sf = this.getAllSubFunnels.findIndex(item => item.id === this.funnel.id);
		  if (sf>=0) this.getAllSubFunnels.splice(sf, 1);
	  },
    async deleteFunnel() {
      try {
        this.loading = true;
        let result = await this.api.funnels.delete(this.funnel.id);
        if (result.error) throw result;

				// remove the funnel from the store.
				this.removeFunnel()

	      this.$emit('done', this.funnel.id);
        this.closePopup();
        if (this.$router.currentRoute.path === '/funnels') {
	        // this.$router.go(0);
        } else {
	        this.$router.push({path: '/funnels'});
        }
      } catch (e) {
        this.$error(e);
      } finally {
        this.loading = false;
      }
    },
  },
}
</script>

<style lang="scss" scoped>

</style>
